import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "../src/dbh_helper";

$(document).ready(function () {

    $('#dbh_historyOpenAdmin').on("click", function () {
        $('#dbh_bodySubmitBlockerGray').show();

        return new dbh_ajax().sendGetRequest({
            actionName: "GetHistoryAdmin",
            controllerName: "Home",
            callbackSuccess: (ajaxResult: any) => {
                $('#dbh_historyWrapper').html(ajaxResult.responseText).css('right', "0");

                $('#dbh_history #btnSessionUserChange').on("click", function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);
                    new dbh_ajax().sendPostRequest({
                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                        actionName: "ChangeUser",
                        controllerName: "Home",
                        parameter: [["id", $('#dbhAdminHistoryFK_KollegIn').val()]],
                        callbackSuccess: (ajaxResult: any) => {
                            window.setTimeout(function () {
                                window.location.href = "/";
                            }, 1000);
                        },
                        callbackError: (ajaxResult: any) => {
                            window.setTimeout(function () {
                                window.location.href = "/";
                            }, 1000);
                        }
                    });
                });
                $('#dbh_history #btnHistoryClose').on("click", function () {
                    if (window.innerWidth >= 600) {
                        $('#dbh_historyWrapper').css('right', "-600px");
                    } else {
                        $('#dbh_historyWrapper').css('right', "-100vw");
                    }
                    window.setTimeout(function () {
                        $('#dbh_bodySubmitBlockerGray').hide();
                        $('#dbh_historyWrapper').html("");
                    }, 1000);
                });
            },
            callbackError: (ajaxResult: object) => {
                console.log(ajaxResult);
            }
        });
    });
    $('#dbh_historyOpenUser').on("click", function () {
        $('#dbh_bodySubmitBlockerGray').show();

        return new dbh_ajax().sendGetRequest({
            actionName: "GetHistoryUser",
            controllerName: "Home",
            callbackSuccess: (ajaxResult: any) => {
                $('#dbh_historyWrapper').html(ajaxResult.responseText).css('right', "0");

                $('#dbh_history #btnHistoryClose').on("click", function () {
                    if (window.innerWidth >= 600) {
                        $('#dbh_historyWrapper').css('right', "-600px");
                    } else {
                        $('#dbh_historyWrapper').css('right', "-100vw");
                    }
                    window.setTimeout(function () {
                        $('#dbh_bodySubmitBlockerGray').hide();
                        $('#dbh_historyWrapper').html("");
                    }, 1000);
                });
            },
            callbackError: (ajaxResult: object) => {
                console.log(ajaxResult);
            }
        });
    });
});

